import React, { useEffect, useState } from "react";
import logo from "../assets/images/Logo/web_logo.png";
import PrimaryBtn from "../components/button/PrimaryBtn";
import { useNavigate } from "react-router-dom";

const SplashScreen = () => {
  const navigate = useNavigate();
  const [animate, setAnimate] = useState(false);

  useEffect(() => {
    const timer = setTimeout(() => {
      setAnimate(true);
    }, 100);
    return () => clearTimeout(timer);
  }, []);

  const handleNavigate = () => {
    navigate("/login");
  };

  return (
    <div className="min-h-screen flex items-center justify-center md:bg-gradient-to-br md:from-orange-50 md:to-orange-100 px-4 md:px-0">
      <div className="w-full max-w-2xl lg:max-w-4xl xl:max-w-7xl md:bg-white md:rounded-2xl md:shadow-2xl grid grid-cols-1 lg:grid-cols-2 md:h-[75vh] lg:h-[50vh] overflow-hidden">
        <div className="relative hidden md:flex flex-col justify-center p-12 bg-gradient-to-br from-orange-400 to-orange-500 text-white">
          <div className="absolute w-40 h-40 rounded-full bg-white/20 -top-12 -left-12" />
          <div className="absolute w-28 h-28 rounded-full bg-white/20 -bottom-10 -right-10" />

          <h1 className="text-4xl font-bold mb-5">Tiffin Tap</h1>
          <p className="text-base opacity-95 mb-8">Wow Taste. Wow Health.</p>

          <div className="flex flex-wrap gap-3">
            <span className="px-4 py-2 rounded-full bg-white/20 text-sm">
              🥗 Healthy
            </span>
            <span className="px-4 py-2 rounded-full bg-white/20 text-sm">
              ⏰ On Time
            </span>
            <span className="px-4 py-2 rounded-full bg-white/20 text-sm">
              🏠 Home Made
            </span>
          </div>
        </div>

        <div className="flex flex-col items-center md:items-start text-center md:text-left p-6 md:p-12 h-full md:h-full min-h-screen md:min-h-0">
          <div className="flex flex-col items-center md:items-start justify-center flex-1">
            <img
              src={logo}
              alt="Tiffin Tap Logo"
              className={`w-34 h-32 mb-5 transform transition-all duration-700 ease-out ${
                animate
                  ? "opacity-100 translate-y-0"
                  : "opacity-0 translate-y-6"
              }`}
            />

            <div
              className={`space-y-1 transform transition-all duration-700 delay-200 ease-out ${
                animate
                  ? "opacity-100 translate-y-0"
                  : "opacity-0 translate-y-6"
              }`}
            >
              <p className="text-gray-800 text-base font-medium">
                You cook, we manage the rest.
              </p>
              <p className="text-gray-500 text-sm">
                Built for home-based tiffin providers.
              </p>
            </div>
          </div>

          <div
            className={`w-full pb-4 md:pb-0 mt-auto md:mt-0 transform transition-all duration-700 delay-400 ease-out ${
              animate ? "opacity-100 translate-y-0" : "opacity-0 translate-y-6"
            }`}
          >
            <PrimaryBtn
              btnName="Get Started"
              extraClass="w-full"
              clickEvent={handleNavigate}
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default SplashScreen;
